import { AfterViewInit, ChangeDetectorRef, Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import Map from 'ol/Map';
import { View } from 'ol';
import Overlay from 'ol/Overlay';
import Feature from 'ol/Feature';
import Point from 'ol/geom/Point';
import * as layer from 'ol/layer';
import { Tile as Tile, Vector as VectorLayer, Image as ImageLayer } from 'ol/layer';
import { OSM as OSM, Vector as VectorSource, Vector as MeasureSource } from 'ol/source';
import { WFS, GeoJSON } from 'ol/format';
import ImageWMS from 'ol/source/ImageWMS';
import { Icon, Style, Fill, Stroke } from 'ol/style';
import * as control from 'ol/control';
import * as proj from 'ol/proj';
import KML from 'ol/format/KML';

@Component({
  selector: 'app-apogeometrymapview',
  templateUrl: './apogeometrymapview.component.html',
  styleUrls: ['./apogeometrymapview.component.css']
})
export class ApogeometrymapviewComponent implements OnChanges, OnDestroy {
  @Input() mapPreviewGeojsonInfo: string | null = null;
   private map: Map | null = null;
   private popup: Overlay | null = null;
  private allowedProps: string[] = [];

   constructor() {}

   ngOnChanges(changes: SimpleChanges): void {
     if (changes['mapPreviewGeojsonInfo']) {
       const newGeojson = changes['mapPreviewGeojsonInfo'].currentValue;
       if (newGeojson) {
         this.loadGeoJsonPreview(newGeojson);
       } else {
         this.clearMap();
       }
     }
   }

   ngOnDestroy(): void {
     this.clearMap();
   }

   private loadGeoJsonPreview(info: { geojson: string; geojsonProps: string }): void {
    try {
      //console.log(info)
      const geojson = JSON.parse(info.geojson);
      this.allowedProps = info.geojsonProps
        ? info.geojsonProps.split(',').map(prop => prop.trim())
        : [];
      const features = new GeoJSON().readFeatures(geojson, {
        featureProjection: 'EPSG:3857'
      });
      if (!features.length) return this.clearMap();

       if (features.length === 0) {
           console.warn('No features found in KML file');
           this.clearMap();
           return;
         }

         // Create a vector source and layer for the KML features
         const vectorSource = new VectorSource({
           features: features
         });

         const _style=new Style({
               stroke: new Stroke({
                 color: 'rgba(244, 7, 7, 0.9)' ,
                 width: 2
               }),
               fill: new Fill({
                   color: 'rgba(0, 0, 0, 0)'  // Transparent fill
                 })
             });
         const vectorLayer = new VectorLayer({
           source: vectorSource,
           style: _style
         });

         // Initialize or update the map
         this.clearMap(); // Clean up any existing map

         this.map = new Map({
           target: 'preview-map',
           layers: [
             new Tile({
               source: new OSM()
             }),
             vectorLayer
           ],
           view: new View({
             center: [0, 0], // Will be set by fit
              zoom: 6,
              maxZoom: 23,
              minZoom: 5,
           }),
          // controls: [], // Remove default controls for a cleaner preview
           //interactions: [] // Disable interactions for preview
         });

         // Fit the map to the extent of the KML features
         const extent = vectorSource.getExtent();
         if (!isFinite(extent[0]) || !isFinite(extent[1]) || !isFinite(extent[2]) || !isFinite(extent[3])) {
           console.warn('Invalid Geometry extent');
           this.clearMap();
           return;
         }

         this.map.getView().fit(extent, {
           padding: [10, 10, 10, 10],
           maxZoom: 15,
           duration: 0
         });

          // Initialize popup overlay
       const popupElement = document.getElementById('popup');
       if (popupElement) {

          this.popup = new Overlay({
         element: popupElement,
         autoPan: true,
         autoPanAnimation: {
           duration: 250
         }
       });
         this.map.addOverlay(this.popup);
       }


        // Pointermove event to change cursor on hover
     this.map.on('pointermove', (event) => {
       const pixel = event.pixel;
       const feature = this.map!.forEachFeatureAtPixel(pixel, (feat) => feat, {
         hitTolerance: 10 // Match the click tolerance
       });

       // Change cursor to pointer if a feature is found, otherwise revert to default
       const mapElement = this.map!.getTargetElement();
       mapElement.style.cursor = feature ? 'pointer' : 'auto';
     });
      this.map.on('click', (event) => {
       const pixel = event.pixel;
       const feature = this.map!.forEachFeatureAtPixel(pixel, (feat) => feat, {
         hitTolerance: 10
       });
       if (feature) {
         const coordinates = (feature.getGeometry() as Point).getCoordinates();
         const properties = feature.getProperties();
         this.showPopup(coordinates, properties);
       } else {
         this.popup?.setPosition(undefined);
       }
       });

    } catch (e) {
      console.error('Invalid GeoJSON', e);
      this.clearMap();
    }
  }
     private showPopup(coordinates: number[], properties: any): void {
     //console.log("showPopup()");
     //console.log("coordinates",coordinates)
        //console.log("properties",properties);
     if (!this.popup) return;

     const content = document.getElementById('popup-content');
     if (content) {
       // Build the popup HTML with a table structure
       let popupHtml = `
         <button class="popup-close">×</button>
         <table class=" table table-hover table-bordered  popup-table" >
           <thead class="table-header">
             <tr>
               <th>Field</th>
               <th>Value</th>
             </tr>
           </thead>
           <tbody>
             <tr>
               <td> <strong>Name</strong></td>
               <td>${properties.name}</td>
             </tr>
       `;


       popupHtml += `
           </tbody>
         </table>
       `;

       content.innerHTML = popupHtml;

        // Attach click event to the close button programmatically
       const closeButton = content.querySelector('.popup-close');
       if (closeButton) {
         closeButton.addEventListener('click', () => {
           const popupElement = document.getElementById('popup');
           if (popupElement) {
             popupElement.style.display = 'none';
           }
           // Also reset the popup position to hide it in OpenLayers
           this.popup?.setPosition(undefined);
         });
       } else {
         //console.log('Close button not found in popup');
       }
       // Ensure the popup is visible
       const popupElement = document.getElementById('popup');
       if (popupElement) {
         popupElement.style.display = 'block';
       }
     }

     this.popup.setPosition(coordinates);
   }

   private clearMap(): void {
     if (this.map) {
       this.map.setTarget(undefined);
       this.map = null;
     }
   }

   
   private loadKmlPreview(file: File): void {
     const reader = new FileReader();
     reader.onload = (e) => {
       const kmlText = e.target?.result as string;
       if (!kmlText) {
         this.clearMap();
         return;
       }

       try {
         const kmlFormat = new KML();
         const features = kmlFormat.readFeatures(kmlText, {
           featureProjection: 'EPSG:3857' // Project to Web Mercator, used by OpenLayers
         });


       } catch (error) {
         console.error('Error parsing KML file:', error);
         this.clearMap();
       }
     };
     reader.readAsText(file);
   }
 }